import { SelectionGenericService } from './../../../../../selection-generic/services/selection-generic.service';
import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfirmDialogModel } from 'app/modules/common/components/confirmation-dialog/confirm-dialog-model';
import { ConfirmationDialogComponent } from 'app/modules/common/components/confirmation-dialog/confirmation-dialog.component';
import { SharedService } from 'app/modules/common/services/shared-service';
import { ReportsLeaveReportService } from 'app/modules/reports/services/reports-leave-report.service';
import { map } from 'rxjs/operators';

@Component({
    selector: 'app-save-leave-report-name',
    templateUrl: './save-leave-report-name.component.html',
    styleUrls: ['./save-leave-report-name.component.scss'],
    standalone: false
})
export class SaveLeaveReportNameComponent implements OnInit {

    private selectedReportId: number;
    private reportData: any;
    private templateReportList: any[];
    public templateSaveForm: UntypedFormGroup;

    constructor(
        private dialog: MatDialog,
        private sharedService: SharedService,
        private reportsLeaveReportService: ReportsLeaveReportService,
        @Inject(MAT_DIALOG_DATA) private dialogData: any,
        public dialogRef: MatDialogRef<SaveLeaveReportNameComponent>,
        public formBuilder: UntypedFormBuilder,
        private _selectionService: SelectionGenericService,
    ) {
        this.selectedReportId = this.dialogData.selectedReportId;
        this.reportData = this.dialogData.reportData;
       
    }

    ngOnInit(): void {
        this.templateSaveForm = this.formBuilder.group({
            TemplateName: [null, Validators.required]
        });
        this.getAllTemplateNames();
    }

    public addOrUpdateTemplate(): void {
        //template name input by user
        const name = this.templateSaveForm.value.TemplateName.trim();

        if (this.templateReportList.find(t => String(t['viewValue']).toLowerCase() == String(name).toLowerCase())) {
            //restrict updating the default template 
            if (String("Completo").toLowerCase() === String(name).toLowerCase()) {
                this.sharedService.ShowSnackBar('No se puede actualizar la plantilla por defecto');
            } else {
                const dialogData = new ConfirmDialogModel('Este informe ya existe. ¿Quieres reemplazarlo?', "");
                const PopupDialogRef = this.dialog.open(ConfirmationDialogComponent, {
                    data: dialogData
                });

                PopupDialogRef.afterClosed().subscribe(responce => {
                    this.selectedReportId = this.templateReportList.find(t => String(t['viewValue']).toLowerCase() == String(name).toLowerCase()).value;
                    if (responce) {
                        this.updateTemplate(this.selectedReportId);
                        this.dialogRef.close(this.selectedReportId);
                    }
                });
            }
        } else {
            this.addTemplate(name).subscribe(newTemplateId => {
                this.dialogRef.close(newTemplateId);
            }, err => {
                this.sharedService.ShowSnackBar('api Se produjo un error');
                console.error(err);
            });
        }
    }

    public closePopup(): void {
        this.dialogRef.close();
    }

    /**
     * Add new template and return its ID
     * @param name Template name
     */
    private addTemplate(name: any) {
        //add new template    
        this.reportData.Nombre = name;

        return this.reportsLeaveReportService.addTemplate(this.reportData)
            .pipe(map(res => {
                if (res.code === 0) {
                    this.sharedService.ShowSnackBar('Añadido con éxito');
                    return res.result as number;
                } else {
                    this.sharedService.ShowSnackBar('file Se produjo un error');
                    return null;
                }
            }));

    }

    private updateTemplate(selectedReportId) {
        //update existing templates
        this.reportData.InformeId = selectedReportId;
        this.reportsLeaveReportService.updateTemplate(this.reportData)
            .subscribe(res => {
                if (res.code === 0) {
                    this.sharedService.ShowSnackBar('Plantilla guardada');
                } else {
                    this.sharedService.ShowSnackBar('file Se produjo un error');
                }
            }, err => {
                this.sharedService.ShowSnackBar('api Se produjo un error');
                console.error(err);
            });
    }

    private getAllTemplateNames(): void {
        this.reportsLeaveReportService.getAllTemplateNames().subscribe(res => {
            if (res.code === 0) {
                this.templateReportList = res.result;
            } else {
                this.sharedService.ShowSnackBar('falló');
            }
        }, error => {
            this.sharedService.ShowSnackBar('falló');
        });
    }
}
